import { IComponentOptions } from "angular";
import { ContractDetailsViewController } from "./controller";

export const vsName = "machineDetailContractComponent";

export const machineDetailContractComponentOptions: IComponentOptions = {
  controller: ContractDetailsViewController,
  controllerAs: "stateController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    contracts: "=",
    contract: "<",
    contractMachines: "<",
  },
};
